export interface PlannerDateTime {
  date: string
  time: string
}

export function timeSeconds(time: string): number {
  const [hours, minutes] = time.split(':').map(Number)
  return hours * 3_600 + minutes * 60
}

export function discoveryDeparture(
  selection: PlannerDateTime & { intent: 'depart-at' | 'arrive-by' },
  availableDates: string[],
): PlannerDateTime {
  if (selection.intent === 'depart-at') return selection
  const seconds = timeSeconds(selection.time) - 2 * 60 * 60
  if (seconds >= 0) return { date: selection.date, time: serviceTime(seconds) }
  const previousDate = addServiceDays(selection.date, -1)
  return availableDates.includes(previousDate)
    ? { date: previousDate, time: serviceTime(seconds + 86_400) }
    : { date: selection.date, time: '00:00' }
}

function serviceTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60)
  return `${Math.floor(minutes / 60).toString().padStart(2, '0')}:${(minutes % 60).toString().padStart(2, '0')}`
}

export function newYorkDateTime(now = new Date(), roundMinutes = 1): PlannerDateTime {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(now)
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value ?? ''
  const date = `${part('year')}${part('month')}${part('day')}`
  const minutes = Number(part('hour')) * 60 + Number(part('minute'))
  const rounded = Math.ceil(minutes / roundMinutes) * roundMinutes
  return {
    date: addServiceDays(date, Math.floor(rounded / 1_440)),
    time: `${Math.floor((rounded % 1_440) / 60).toString().padStart(2, '0')}`
      + `:${(rounded % 60).toString().padStart(2, '0')}`,
  }
}

export function upcomingServiceDates(now = new Date(), count = 7): string[] {
  const today = newYorkDateTime(now).date
  return Array.from({ length: count }, (_, index) => addServiceDays(today, index))
}

export function addServiceDays(date: string, days: number): string {
  const value = new Date(Date.UTC(
    Number(date.slice(0, 4)),
    Number(date.slice(4, 6)) - 1,
    Number(date.slice(6, 8)) + days,
  ))
  return `${value.getUTCFullYear()}${(value.getUTCMonth() + 1).toString().padStart(2, '0')}`
    + `${value.getUTCDate().toString().padStart(2, '0')}`
}
